export default __webpack_public_path__ + "static/media/slide-2.8d7a281e.png";